// Pre-chat form and proactive greeting - widget settings (widgets.settings_override),
// normalised the same way as api/core/engagement.py. Both are off by default.

export type FieldMode = "off" | "optional" | "required";

export type PreChatForm = {
    enabled: boolean;
    name: FieldMode;
    email: FieldMode;
    // shown above the fields; empty = the widget's default text
    intro: string;
};

export type Proactive = {
    enabled: boolean;
    // one greeting per widget language; empty = the widget's default greeting in that language
    messageEn: string;
    messageSr: string;
    delaySeconds: number;
    onlyWhenOnline: boolean;
};

const MODES: FieldMode[] = ["off", "optional", "required"];

export function normalizePreChat(raw: unknown): PreChatForm {
    const r = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>;
    const name = MODES.includes(r.name as FieldMode) ? (r.name as FieldMode) : "optional";
    const email = MODES.includes(r.email as FieldMode) ? (r.email as FieldMode) : "required";
    return {
        enabled: !!r.enabled && !(name === "off" && email === "off"),
        name,
        email,
        intro: String(r.intro ?? "").trim().slice(0, 300),
    };
}

export function normalizeProactive(raw: unknown): Proactive {
    const r = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>;
    const delay = Number(r.delaySeconds ?? 20);
    const text = (v: unknown) => String(v ?? "").trim().slice(0, 200);
    // older settings had a single "message" - it carries over to both languages
    const legacy = text(r.message);
    const hasPerLang = "messageEn" in r || "messageSr" in r;
    return {
        enabled: !!r.enabled,
        messageEn: hasPerLang ? text(r.messageEn) : legacy,
        messageSr: hasPerLang ? text(r.messageSr) : legacy,
        delaySeconds: Number.isFinite(delay) ? Math.max(5, Math.min(Math.round(delay), 300)) : 20,
        onlyWhenOnline: r.onlyWhenOnline !== false,
    };
}

// the greeting shows at most once per visit, and not again for a week after the visitor
// closes it
export const GREETING_SESSION_KEY = "cw_greeting_shown";
export const GREETING_DISMISSED_KEY = "cw_greeting_dismissed_until";
export const GREETING_SNOOZE_MS = 7 * 24 * 3600 * 1000;
